// Both card navigation and Review work use the same bookmarkable destination.
// The task route resolves accessible responses, including already-reviewed work.
export const taskLink = (task, role) => {
  const link = typeof task.link === 'string' ? task.link.trim() : '';
  const path = (link || (task.id ? `/tasks/${task.id}` : '/tasks')).replace(
    /^#?\/?/,
    '/'
  );
  const reviewLink = path.match(/^\/submissions\/([^/?#]+)\/review(?:[/?#]|$)/);
  return role === 'TEACHER' && reviewLink
    ? `#/submissions/${reviewLink[1]}`
    : `#${path}`;
};
